export default class OnlineContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "FindPlayer";
  }

  async show(path) {
    const app = this.app;
    const pageId = this.pageId;
    const userdata = app.userdata;


    if (!userdata.friends) userdata.friends = [];
    if (!userdata.blockedPlayers) userdata.blockedPlayers = [];
    let friends = userdata.friends;
    let blockedPlayers = userdata.blockedPlayers.length + "";
    let isOnFacebook = app.isOnFacebook;
    let model = {
      friends: friends,
      isOnFacebook: isOnFacebook,
      blockedPlayers: blockedPlayers,
      id: userdata.id
    }

    app.populate(pageId, model);
    app.swapPage(pageId);

  }
  inviteFb() {
    const app = this.app;
    app.fBInstantGame.inviteSend(app.userdata, app.userdata.id + "");
  }
  invitePlayer(userId, facebookId, isTrusted, room) {
    const app = this.app;
    if (!room) room = app.userdata && app.userdata.id + "";
    if (!room) room = Math.floor(Math.random() * Math.floor(100000000)) + "";

    let name = app.userdata && app.userdata.name;

    //todo: only join room once.

    //facebook invite
    if (facebookId) {
      let sentInviteFB = app.fBInstantGame.invitePlayer(facebookId, room);
      //room is joined on the onFBInvite, could change to promise
      // if (sentInviteFB) {
      //   this.createNotification("Invite sent via FB");
      //   this.joinCustomRoom(room);
      // }
    }

    //Push notification invite
    //trusted = invite by email or by number, not by recent games or in game
    if (isTrusted == true) {
      app.gamification.InviteSend(name, userId, room, null).then(function (sent) {
        if (sent) {
          app.createNotification("Invite sent via Push Notification");
          app.joinCustomRoom(room);
        }
      }.bind(this));
    }

    //Game socket invite
    if (app.gameServer) {
      console.log(`socketClient.invite userId:${userId}, room:${room}`)
      app.gameServer.invite(userId, room).then(function (data) {
        app.createNotification(data);
        if (data === "Invite sent") {
          app.joinCustomRoom(room);
        }
      }.bind(this));

    }

  }
  clearblockPlayers() {
    const app = this.app;
    app.userdata.blockedPlayers = [];

    //update socket server data
    if (app.gameServer) app.gameServer.login(app.userdata);
    app.navigate('FindPlayer');
  }
  findPlayer(search) {
    const app = this.app;
    let value = parseInt(search, 10);

    //serach by Id
    if (value) {
      let id = value;
      this.findPlayerById(id);
    }
    //search by email
    if (!value) {
      let email = search;
      this.findPlayerByEmail(email);
    }
  }
  findPlayerById(id) {
    const app = this.app
    app.gamification.GetUser(id).then(function (user) {
      if (!user) {
        app.createNotification("No user found");
        return;
      }
      app.addFriend({
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      });
      app.navigate('FindPlayer');
    }.bind(this));
  }
  findPlayerByEmail(email) {
    const app = this.app
    app.gamification.FindUser(null, null, email).then(function (user) {
      if (!user) {
        app.createNotification("No user found");
        return;
      }
      app.addFriend({
        id: user.Id,
        avatar: user.Avatar,
        name: user.Name,
        facebookId: user.FacebookId,
        trusted: true
      });
      app.navigate('FindPlayer');
    }.bind(this));
  }
  addFriend(user) {
    const app = this.app;
    app.addFriend(user);
  }
  removeFriend(id) {
    const app = this.app
    let friends = app.userdata.friends;
    app.userdata.friends = friends.filter(function (obj) {
      return obj.id != id;
    });
    app.navigate('FindPlayer');
  }
}